import moment from "moment";
import React from "react";
import { CloseCircleOutlined } from "@ant-design/icons";
import "./index.css";

const TIME_FORMAT = "HH:mm";
const DISPLAY_TIME_FORMAT = "HH:mm a";

const Timeslot = ({ start, end, handleDelete, showCloseIcon = true, selectedRoom }) => (
  <div className="timeslot-container">
    {showCloseIcon && (
      <CloseCircleOutlined
        onClick={handleDelete}
        className="timeslot-icon"
        style={{ fontSize: "18px", color: "#ffffff" }}
      />
    )}
    <div className="timeslot-time">
      {moment(start, TIME_FORMAT).format(DISPLAY_TIME_FORMAT)} - {moment(end, TIME_FORMAT).format(DISPLAY_TIME_FORMAT)}
      {selectedRoom ? ` at room ${selectedRoom}` : ""}
    </div>
  </div>
);

export default Timeslot;
